import {
  Button,
  HStack,
  Icon,
  Image,
  Text,
  Tooltip,
  VStack,
} from "@chakra-ui/react";
import { Clock, UsersThree } from "@phosphor-icons/react";
import { Link } from "react-router-dom";
import { iconSize } from "../../const/sizes";
import { Course } from "../../const/types";
import formatDuration from "../../lib/formatDuration";
import formatNumber from "../../lib/formatNumber";
import formatNumberShort from "../../lib/formatNumberShort";

type Props = {
  data: Course;
};

export default function CourseCard({ data }: Props) {
  return (
    <VStack
      gap={0}
      borderRadius={8}
      overflow={"hidden"}
      align={"stretch"}
      boxShadow={"0 0 5px 2px var(--divider)"}
      border={"1px solid var(--divider3)"}
    >
      <Image
        src={`${process.env.REACT_APP_MEDIA_BASE_URL}${data.image}`}
        borderRadius={0}
        objectFit={"cover"}
        aspectRatio={"16/9"}
        // mb={4}
      />

      <VStack align={"stretch"} p={4} flex={1}>
        <Tooltip>
          <Text
            fontSize={20}
            fontWeight={700}
            lineHeight={1.4}
            noOfLines={2}
            mb={8}
          >
            {data.nama_course}
          </Text>
        </Tooltip>

        <HStack justify={"space-between"} opacity={0.5} mt={"auto"}>
          <HStack>
            <Icon as={Clock} fontSize={iconSize} />
            <Text>{formatDuration(data.total_duration)}</Text>
          </HStack>

          <Tooltip label={`${formatNumber(data?.totalmembers)} mengukuti`}>
            <HStack>
              <Icon as={UsersThree} fontSize={20} />

              <Text noOfLines={1}>{formatNumberShort(data?.totalmembers)}</Text>
            </HStack>
          </Tooltip>
        </HStack>
      </VStack>

      {!data.is_joined ? (
        <Button
          h={"50px"}
          // borderRadius={0}
          colorScheme="ap"
          className="btn-ap clicky"
          as={Link}
          to={`/allcourses/${data.id}`}
        >
          Gabung Course
        </Button>
      ) : (
        <Button
          h={"50px"}
          // borderRadius={0}
          colorScheme="ap"
          variant={"ghost"}
          as={Link}
          to={`/mycourse/${data.id}?index=0`}
        >
          Mulai Belajar
        </Button>
      )}
    </VStack>
  );
}
